import { render, staticRenderFns } from "./host-set-channel.vue?vue&type=template&id=3253ae00&scoped=true&"
import script from "./host-set-channel.vue?vue&type=script&lang=js&"
export * from "./host-set-channel.vue?vue&type=script&lang=js&"
import style0 from "./host-set-channel.vue?vue&type=style&index=0&id=3253ae00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3253ae00",
  null
  
)

export default component.exports